(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ploumi-free-shipping-pack"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ploumi-shipping-pack')){customElements.define('ploumi-shipping-pack',class extends HTMLElement{connectedCallback(){this.button=this.querySelector('[data-add-pack]');this.status=this.querySelector('[data-pack-status]');if(!this.button||this.button.disabled)return;this.button.addEventListener('click',()=>this.addPack())}async addPack(){const label=this.button.textContent.trim();this.button.disabled=true;this.button.textContent=this.button.dataset.loadingLabel;this.status.textContent='';try{const r=await fetch(this.dataset.cartAddUrl,{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(this.button.dataset.bioVariant),quantity:4},{id:Number(this.button.dataset.classicVariant),quantity:3}]})});if(!r.ok)throw new Error('cart');window.location.assign(this.dataset.cartUrl)}catch(e){this.status.textContent=this.getAttribute('data-error-label');this.button.disabled=false;this.button.textContent=label}}})}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ploumi-whatsapp-bubble"] && !Shopify.designMode) return;
  try {
    const pushWhatsAppEvent = (event) => {
  const link = event.target.closest('[data-ploumi-whatsapp]');
  if (!link) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'ploumi_whatsapp_click',
    page_path: window.location.pathname
  });
};

const positionUserWayLauncher = () => {
  const icon = document.getElementById('userwayAccessibilityIcon');
  if (!icon) return;

  const wrapper = icon.closest('.userway_buttons_wrapper') || document.querySelector('.userway_buttons_wrapper');
  const mobile = window.matchMedia('(max-width: 749px)').matches;
  const size = mobile ? '48px' : '52px';
  const left = mobile ? '12px' : '16px';
  const sticky = mobile ? document.querySelector('.ploumi-mobile-sticky-atc') : null;
  const stickyHeight = sticky ? Math.ceil(sticky.getBoundingClientRect().height) : 0;
  const bottom = mobile && stickyHeight > 0 ? `${stickyHeight + 14}px` : (mobile ? '14px' : '18px');

  document.documentElement.style.setProperty('--ploumi-mobile-float-bottom', bottom);
  const whatsapp = document.querySelector('[data-ploumi-whatsapp]');
  if (whatsapp) whatsapp.style.setProperty('bottom', bottom, 'important');

  if (wrapper) {
    wrapper.style.setProperty('position', 'fixed', 'important');
    wrapper.style.setProperty('left', left, 'important');
    wrapper.style.setProperty('right', 'auto', 'important');
    wrapper.style.setProperty('top', 'auto', 'important');
    wrapper.style.setProperty('bottom', bottom, 'important');
    wrapper.style.setProperty('width', size, 'important');
    wrapper.style.setProperty('height', size, 'important');
    wrapper.style.setProperty('min-width', size, 'important');
    wrapper.style.setProperty('min-height', size, 'important');
    wrapper.style.setProperty('transform', 'none', 'important');
    wrapper.style.setProperty('overflow', 'visible', 'important');
    wrapper.style.setProperty('z-index', '2147482999', 'important');
  }

  icon.style.setProperty('position', 'absolute', 'important');
  icon.style.setProperty('left', '0', 'important');
  icon.style.setProperty('right', 'auto', 'important');
  icon.style.setProperty('top', '0', 'important');
  icon.style.setProperty('bottom', 'auto', 'important');
  icon.style.setProperty('transform', 'none', 'important');
  icon.style.setProperty('width', size, 'important');
  icon.style.setProperty('height', size, 'important');
  icon.style.setProperty('min-width', size, 'important');
  icon.style.setProperty('min-height', size, 'important');
  icon.style.setProperty('background', '#11120f', 'important');
  icon.style.setProperty('border', '1px solid #d8b460', 'important');
  icon.style.setProperty('border-radius', '999px', 'important');
  icon.style.setProperty('box-shadow', '0 5px 14px rgba(0,0,0,.20)', 'important');
  icon.style.setProperty('visibility', 'visible', 'important');
  icon.style.setProperty('opacity', '1', 'important');
  icon.style.setProperty('z-index', '2147483000', 'important');

  icon.querySelectorAll('.uiiw, .ui_w').forEach((node) => {
    node.style.setProperty('display', 'block', 'important');
    node.style.setProperty('visibility', 'visible', 'important');
    node.style.setProperty('opacity', '1', 'important');
    node.style.setProperty('filter', 'brightness(0) invert(1)', 'important');
  });
};

document.addEventListener('click', pushWhatsAppEvent);
window.addEventListener('resize', positionUserWayLauncher, { passive: true });

[0, 250, 800, 1600, 3000].forEach((delay) => {
  window.setTimeout(positionUserWayLauncher, delay);
});

const userWayObserver = new MutationObserver(positionUserWayLauncher);
userWayObserver.observe(document.documentElement, { childList: true, subtree: true });
window.setInterval(positionUserWayLauncher, 1200);
  } catch(e) { console.error(e); }
})();

})();
